export class LowerCaseValueConverter {
    fromView(value:string) {
        return (value || "").toLowerCase();
    }
    toView(value:string) {
        return (value || "").toLowerCase();
    }
}